<template>
    <el-header>
        <el-row
            :gutter="10"
            class="header-wrapper"
            justify="space-between"
            align="middle"
        >
            <!-- Logo -->
            <el-col :span="20">
                <div class="logo-wrapper">
                    <a
                        :href="currentUrl + '/web-search/results/de'"
                        class="logo-link"
                        v-if="groupName === 'Deutsche Interim AG'"
                    >
                        <img
                            class="logo"
                            src="/media/images/web_search/logo.svg"
                            alt="Logo"
                        />
                        <span class="header-company-name">
                            Deutsche<br />Interim AG
                        </span>
                    </a>
                    <a
                        :href="currentUrl + '/web-search/results/de'"
                        class="logo-link"
                        v-else-if="groupName === 'Swiss Interim GmbH'"
                    >
                        <img
                            class="logo-swiss"
                            src="/media/images/web_search/logo_swiss.png"
                            alt="Logo"
                        />
                    </a>
                    <a
                        :href="currentUrl + '/web-search/results/de'"
                        class="logo-link"
                        v-else
                    >
                        <img
                            class="logo-matchmaker"
                            src="/media/images/web_search/logo_matchmaker.svg"
                            alt="Logo"
                        />
                    </a>
                </div>
            </el-col>

            <!-- Right section: language switch + avatar -->
            <el-col :span="4" class="right-section" style="text-align: right">
                <!-- Language switch -->
                <div class="language-switch" style="margin-bottom: 10px">
                    <span
                        :class="{ active: currentLang === 'en' }"
                        @click="switchLang('en')"
                        style="cursor: pointer"
                    >
                        en
                    </span>
                    |
                    <span
                        :class="{ active: currentLang === 'de' }"
                        @click="switchLang('de')"
                        style="cursor: pointer"
                    >
                        de
                    </span>
                </div>
                <!-- Avatar + name with dropdown -->
                <el-dropdown @command="handleCommand" v-if="user">
                    <div
                        class="user-info"
                        style="
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                        "
                    >
                        <img
                            :src="userAvatar"
                            alt="avatar"
                            style="
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                margin-right: 8px;
                            "
                        />
                        <span
                            class="user-name"
                            style="font-size: 14px; margin-right: 4px"
                        >
                            {{ user.user_name }}
                        </span>
                        <el-icon><ArrowDown /></el-icon>
                    </div>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item command="logout">{{
                                $trans("profile_dossier.logout")
                            }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </el-col>
        </el-row>
    </el-header>
</template>

<script>
import { ArrowDown } from "@element-plus/icons-vue";

export default {
    name: "HeaderComponent",
    components: {
        ArrowDown,
    },
    props: {
        groupName: String,
    },
    data() {
        return {
            config: window.config || {},
            user: window.user || null,
            currentLang: window.config?.current_language || "en",
            currentUrl: window.location.origin,
        };
    },
    computed: {
        userAvatar() {
            if (
                this.user &&
                this.user.avatar &&
                this.user.avatar.startsWith("http")
            ) {
                return this.user.avatar;
            }

            // Fallback
            return `https://ui-avatars.com/api/?name=${encodeURIComponent(
                this.user?.user_name || "User"
            )}&background=a0a0a0&color=fff&font-size=0.4`;
        },
    },
    methods: {
        switchLang(lang) {
            this.currentLang = lang;
            const url =
                lang === "en"
                    ? this.config.language_en
                    : this.config.language_de;

            if (url) {
                window.location.href = url;
            }
        },
        handleCommand(command) {
            if (command === "logout") {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = this.config.logout_route;

                const token = document.querySelector('meta[name="csrf-token"]');
                if (token) {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = "_token";
                    input.value = token.content;
                    form.appendChild(input);
                }

                document.body.appendChild(form);
                form.submit();
            }
        },
    },
};
</script>

<style scoped>
.language-switch .active {
    font-weight: bold;
}

.user-info:focus {
    outline: none !important;
    box-shadow: none !important;
}

.activeSectionHighlight {
    border: 2px solid #409eff;
    background-color: #ecf5ff;
    border-radius: 4px;
}

.el-header {
    top: 0;
    z-index: 1000;
    height: 95px;
    border-bottom: 1px solid #bcbab6;
    margin: 0 auto;
    width: 100%;
}

.logo {
    width: 85px;
}

.cv-logo-img {
    width: 75px;
}

.logo-wrapper {
    display: flex;
    align-items: center;
}

.header-company-name {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 23px;
    font-weight: 500;
    margin-top: 34px;
}

.cv-header-company-name {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 16px;
    font-weight: 500;
    margin-top: 34px;
}

.logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.logo-swiss {
    width: 160px;
}

.logo-matchmaker {
    width: 85px;
    margin-bottom: 13px;
    margin-top: 67px;
}

.cv-preview {
    width: 794px;
    margin: 0 auto;
    background: #f9f9f9;
    height: 100%;
}

.cv-page {
    position: relative;
    width: 794px;
    height: 806px;
    background: white;
    border: 1px solid #ccc;
    margin-bottom: 16px;
    overflow: hidden;
    page-break-after: always;
    word-break: break-word;
    white-space: normal;
    height: 1122px;
    padding: 40px;
    box-sizing: border-box;
    page-break-after: always;
    background: white;
    padding: 20px;
    border: 1px solid #ddd;
    min-height: 842px;
    position: relative;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    page-break-after: always;
    display: flex;
    flex-direction: column;
    min-height: 800px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    margin-bottom: 20px;
}

.cv-section {
    flex: 1 1 auto;
}

.cv-footer {
    font-size: 12px;
    color: #666;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    margin-top: 20px;
    text-align: center;
    position: relative;
}

.cv-footer-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 5px;
    text-align: left;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.cv-footer-table td {
    vertical-align: top;
    padding: 0 10px;
    border-left: 1px solid #ccc;
}

.cv-footer-table td:first-child {
    border-left: none;
}

.cv-footer-bottom-line {
    border-bottom: 1px solid #ccc;
    width: 100%;
    margin-top: 10px;
}

.cv-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 8px 16px;
    text-align: center;
}

.cv-title {
    font-size: 20px;
    font-weight: bold;
}

.cv-logo {
    position: absolute;
    top: 70px;
    right: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.cv-name {
    margin-top: 4px;
    font-size: 16px;
}

.cv-body {
    position: absolute;
    top: 90px;
    bottom: 16px;
    left: 16px;
    right: 16px;
    overflow: hidden;
}

.cv-section {
    margin-bottom: -11px;
}

.cv-section h3 {
    margin: 8px 0;
    font-size: 16px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 4px;
}

.cv-content {
    font-size: 14px;
}

.cv-preview {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.cv-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.cv-title {
    font-size: 20px;
    font-weight: bold;
}

.cv-name {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 600;
}

.cv-section {
    margin-top: 20px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.section-title .dossier-title {
    font: normal 400 40px/0px Barlow;
}

.section-title .name-title {
    font: normal 400 30px/24px Barlow;
}

.section-content {
    margin-top: 10px;
    white-space: pre-wrap;
}

.cv-photo {
    max-width: 150px;
    margin-top: 10px;
}

.active-section-highlight {
    border: 2px solid #409eff;
    background-color: #f0f9ff;
}

.cv-cover-page {
    padding: 40px;
    font-family: "Arial", sans-serif;
    page-break-after: always;
    margin-top: 25%;
}

.cv-cover-page .title {
    font: normal 400 30px/24px Barlow;
}

.cv-cover-page .name {
    font: normal 400 59px/48px Barlow;
    margin-top: 14px;
}

.cv-cover-page .cover-meta p {
    margin-top: 20px;
    font-size: 21px;
}

.cover-page-cv-footer {
    font-size: 12px;
    color: #666;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    margin-top: 20px;
    position: absolute;
    bottom: 20px;
    width: 88%;
    left: 6%;
    box-sizing: border-box;
}

.cover-page-cv-footer p.cover-disclaimer {
    text-align: justify;
    margin-bottom: 8px;
}

.cover-footer-divider {
    border: none;
    border-top: 1px solid #ccc;
    margin: 8px 0;
}

.cover-footer-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.cover-footer-table td:first-child {
    border-left: none;
}

.cover-footer-table td {
    vertical-align: top;
    padding-right: 15px;
    border-left: 1px solid #ccc;
    padding: 0 10px;
}

.cv-photo {
    width: 150px;
    height: 150px;
    margin: 20px 0;
    border-radius: 50%;
    object-fit: cover;
}

.cover-photo-wrapper {
    text-align: left;
}

.highlight {
    outline: 3px solid #409eff;
    border-radius: 8px;
    transition: outline 0.3s ease;
}
</style>
